import { render } from "./CustomCommissionField.vue?vue&type=template&id=0848a19e"
import script from "./CustomCommissionField.vue?vue&type=script&lang=js"
export * from "./CustomCommissionField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__